function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export const iconStrokeWidth = {
  regular: '16px',
  bold: '24px',
  filled: undefined
};
export const iconDimension = {
  xs: '8px',
  small: '12px',
  medium: '16px',
  large: '20px',
  xl: '24px'
};
export const IconContainer = ({
  size = 'medium',
  variant,
  fill,
  children,
  ...props
}) => {
  if (!variant) {
    variant = ['xs', 'small'].includes(size) ? 'filled' : 'regular';
  }
  const dimension = iconDimension[size];
  const strokeWidth = iconStrokeWidth[variant];
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: dimension,
    height: dimension,
    strokeWidth: strokeWidth,
    fill: fill,
    stroke: fill,
    viewBox: "0 0 256 256",
    role: "img"
  }, props), children);
};
export const FilledIconContainer = ({
  fill,
  children,
  size = 'small'
}) => {
  const dimension = iconDimension[size];
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: dimension,
    height: dimension,
    fill: fill,
    viewBox: "0 0 256 256",
    role: "img"
  }, children);
};